<template>
	<div class="mainContentBackground villageBackground unselectable">
		<div class="sea viewBackground" :style="{top: '0px', left: villageBackgroundLeft, right: 'auto', height: '1440px', transform: 'perspective(1000px) scale3d(1, 1, 1)', transformOrigin: '50% 50%', filter: 'blur(0px)', perspective: '1000px'}">
			<div class="modalWrapper building" style="opacity: 1; top: 400px; align-items: flex-start; justify-content: center; display: flex; width: 100%; height: 100%;">
				<div class="modal building">
					<div class="modalContent">
						<div class="modalDecoration"></div>
						<div class="functionPanel unselectable">
							<a class="closeWindow clickable" @click="$router.push('/township')">
								<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
									<i class="action_cancel_tiny_flat_black"></i>
								</div>
							</a>
						</div>
						<div class="contentHeader unselectable">
							<div>
								<h2 class="msAntiScroll drag" draggable="true">
									<span class="building"><span>Руины</span></span>
								</h2>
								<div class="buildingDescription">
									<span>Руины остаются после разрушения здания. Руины - это источник ресурсов, который ты можешь использовать для восстановления зданий.</span>
								</div>
								<img class="buildingHuge buildingTyperubble" src="//iwstatic.g.bsrv.su/img/x.gif" alt="" data-cmp-info="10" />
							</div>
							<span building-status="" class="buildingStatusButton type_33">
								<div class="buildingStatus location33 busy" ng-class="{
									disabled: upgradeButtonClass == 'notAtAll' || upgradeButtonClass == 'maxLevel',
									busy: busy, queued: finished < 0, waiting: waiting, master: finished > 0 && !busy,
									optionMenu: upgradeButtonClass == 'notNow' || premiumOptionMenu.locationId == building.data.locationId
								}" on-pointer-over="premiumOptionMenu.locationId != building.data.locationId && upgradeButtonClass == 'notNow' && !isRubble ? upgradeBuilding() : ''" tooltip="" tooltip-url="tpl/building/partials/dismantleCostsTooltip.html" tooltip-class="buildingTooltip" tooltip-placement="above" tooltip-offset="10" tooltip-hide="false" tooltip-hide-on-click="false" :content="tooltips[1]" v-tippy="{placement: 'bottom'}">
									<div class="buildingBubble clickable" ng-class="{disabled: upgradeButtonDisabled === true || premiumOptionMenu.locationId == building.data.locationId, disabledHover: upgradeButtonClass == 'notNow'}">
										<div class="colorLayer dismantle demolish" ng-class="{disabled: upgradeButtonClass == 'notAtAll', dismantle: isRubble, enoughRes: !isRubble && enoughRes && freeMasterSlots > 0}">
											<div class="labelLayer">
												<!-- ngIf: !isRubble -->
												<i ng-if="isRubble" class="action_dismantle_small_flat_black"></i>
												<!-- ngIf: upgradeButtonClass == 'maxLevel' -->
											</div>
										</div>
									</div>
									<!-- ngIf: premiumOptionMenu.locationId == building.data.locationId -->
									<div class="progressbar clickable" progressbar="" ng-if="finished > 0" clickable="openBuilding()" finish-time="1727118173" show-countdown="true" duration="1979">
										<!-- ngIf: ::labelIcon -->
										<div class="progress">
											<!-- ngIf: steps -->
											<div class="bar positive perc " style="z-index: 2; width: 2%;"></div>
											<div class="bar additionalBar additionalPerc"></div>
											<div class="marker">
												<div class="markerInner"></div>
											</div>
											<div ng-if="::showCountdown" class="countdown" countdown="1727118173">00:32:19</div>
											<!-- ngIf: ::label -->
											<!-- ngIf: ::percTooltip -->
										</div>
									</div>
									<!-- ngIf: finished < 0 -->
									<!-- ngIf: masterBuilderCount > 0 -->
								</div>
							</span>
							<span building-status="" class="buildingStatusButton type_19">
								<div class="buildingStatus location29 optionMenu" ng-class="{
									disabled: upgradeButtonClass == 'notAtAll' || upgradeButtonClass == 'maxLevel',
									busy: busy, queued: finished < 0, waiting: waiting, master: finished > 0 && !busy,
									optionMenu: upgradeButtonClass == 'notNow' || premiumOptionMenu.locationId == building.data.locationId
								}" on-pointer-over="premiumOptionMenu.locationId != building.data.locationId && upgradeButtonClass == 'notNow' && !isRubble ? upgradeBuilding() : ''" tooltip="" tooltip-url="tpl/building/partials/dismantleCostsTooltip.html" tooltip-class="buildingTooltip" tooltip-placement="above" tooltip-offset="10" tooltip-hide="false" tooltip-hide-on-click="false" :content="tooltips[1]" v-tippy="{placement: 'bottom'}">
									<div class="buildingBubble clickable disabled disabledHover" ng-class="{disabled: upgradeButtonDisabled === true || premiumOptionMenu.locationId == building.data.locationId, disabledHover: upgradeButtonClass == 'notNow'}">
										<div class="colorLayer notNow dismantle" ng-class="{disabled: upgradeButtonClass == 'notAtAll', dismantle: isRubble, enoughRes: !isRubble && enoughRes && freeMasterSlots > 0}">
											<div class="labelLayer">
												<!-- ngIf: !isRubble -->
												<i ng-if="isRubble" class="action_dismantle_small_flat_black"></i>
												<!-- ngIf: upgradeButtonClass == 'maxLevel' -->
											</div>
										</div>
									</div>
									<!-- ngIf: premiumOptionMenu.locationId == building.data.locationId -->
									<!-- ngIf: finished > 0 -->
									<!-- ngIf: finished < 0 -->
									<!-- ngIf: masterBuilderCount > 0 -->
								</div>
							</span>
						</div>
						<div class="heightTransitionContent" :style="{maxHeight: maxHeightContent}">
							<div class="contentTabulation">
								<div class="tabulationContent scrollable tabContent">
									<div class="scrollContentOuterWrapper">
										<div class="scrollContent" style="overflow-y: auto;" :style="{maxHeight: maxHeightInnerContent}">
											<div class="scrollContentInnerWrapper" style="width: auto;">
												<div ng-transclude="">
													<div ng-controller="buildingIndexCtrl" class="building buildingType33" ng-class="{buildingResourceProduction: building.data.buildingType <= 4}">
														<div ng-include="" src="pageTemplate">
															<div class="buildingDetails rubbleDetails">
																<div class="contentBox gradient buildingEffect">
																	<h6 class="contentBoxHeader headerColored">
																		<span translate=""><span>Руины</span></span>
																	</h6>
																	<div class="contentBoxBody">
																		<div class="current">
																			<h6 class="headerTrapezoidal">
																				<div class="content" translate=""><span>Время</span></div>
																			</h6>
																			<div class="timeValue">
																				<i class="symbol_clock_small_flat_black duration"></i>
																				<span>00:32:59</span>
																			</div>
																		</div>
																		<div class="nextLvl">
																			<h6 class="headerTrapezoidal">
																				<div class="content" translate=""><span>Ресурсы</span></div>
																				<div class="maxLvl">
																					<display-resources :resources="building.rubble" :color-positive="true" :signed="true" :check-storage="true" />
																				</div>
																			</h6>
																		</div>
																	</div>
																</div>
																<button clickable="collectRubble()" ng-disabled="!canCollectRubble()" ng-class="{disabled: !canCollectRubble()}" class="clickable disabled" disabled="disabled">
																	<div class="content">
																		<span class="innerText">Разобрать</span>
																		<div class="animationOverlay"></div>
																		<i class="checkmark action_check_small_flat_white"></i>
																		<i class="checkmark action_check_small_flat_black"></i>
																		<i class="checkmark action_check_small_flat_red"></i>
																	</div>
																</button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="window-overlay"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import DisplayResources from '@/components/elements/DisplayResources';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Глиняный карьер | IW'});
	},
	data: () => ({
		maxHeightContent: '550px',
		maxHeightInnerContent: '530px',
		cancelHover: false,
		
		villageBackgroundLeft: '0px',
		
		building: {
			rubble: [7911, 4946, 3958, 2971],
		},
		
		tooltips: {
			1: `<div class="upgradeCostsTooltip">
				<div class="headline">
					<h3 class="building"><span translate="" options="33"><span>Изгородь</span></span></h3>
				</div>
				<div class="content dismantle">
					<div class="contentTopArea">
						<div class="effectDescription">
							<!-- ngIf: upgradeButtonClass == 'demolish' --><span ng-if="upgradeButtonClass == 'demolish'" translate=""><span>Идет разбор</span></span><!-- end ngIf: upgradeButtonClass == 'demolish' -->
							<!-- ngIf: upgradeButtonClass != 'demolish' -->
							<div class="horizontalLine3d"></div>
						</div>
					</div>
			
					<span class="resource timeValue" tooltip="" tooltip-translate="Duration">
								<i class="symbol_clock_small_flat_black duration"></i>00:32:59
							</span>
					<div class="dropOutBox"></div>
			
					<div class="boxDismantle">
						<div class="resources">
							<display-resources resources="building.data.rubble" signed="true" image-size="medium" color-positive="true" check-storage="true"><div class="costs max4digits">
				<!-- ngIf: !checkStorage -->
				<!-- ngIf: checkStorage --><span ng-if="checkStorage">
					<!-- ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><span ng-repeat="(index, type) in resTypes" class="resource woodValue enough" ng-if="resourceVisibility[index]" ng-class="{notEnough: !enoughStorage(index), enough: enoughStorage(index) && colorPositive}" tooltip="" tooltip-translate="Resource_1">
						<i class="unit_wood_medium_illu resType1"></i>
						<!-- ngIf: !onlyProductionPerHour --><span class="resourceValue" ng-if="!onlyProductionPerHour" ng-class="::{strikethrough: showAsOldResources}">&#x202D;+&#x202D;7911&#x202C;&#x202C;</span><!-- end ngIf: !onlyProductionPerHour -->
						<!-- ngIf: ::numberUnit=='production' -->
						<!-- ngIf: productionPerHour[index] || productionPerHour[index] == 0 -->
					</span><!-- end ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><span ng-repeat="(index, type) in resTypes" class="resource clayValue enough" ng-if="resourceVisibility[index]" ng-class="{notEnough: !enoughStorage(index), enough: enoughStorage(index) && colorPositive}" tooltip="" tooltip-translate="Resource_2">
						<i class="unit_clay_medium_illu resType2"></i>
						<!-- ngIf: !onlyProductionPerHour --><span class="resourceValue" ng-if="!onlyProductionPerHour" ng-class="::{strikethrough: showAsOldResources}">&#x202D;+&#x202D;4946&#x202C;&#x202C;</span><!-- end ngIf: !onlyProductionPerHour -->
						<!-- ngIf: ::numberUnit=='production' -->
						<!-- ngIf: productionPerHour[index] || productionPerHour[index] == 0 -->
					</span><!-- end ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><span ng-repeat="(index, type) in resTypes" class="resource ironValue enough" ng-if="resourceVisibility[index]" ng-class="{notEnough: !enoughStorage(index), enough: enoughStorage(index) && colorPositive}" tooltip="" tooltip-translate="Resource_3">
						<i class="unit_iron_medium_illu resType3"></i>
						<!-- ngIf: !onlyProductionPerHour --><span class="resourceValue" ng-if="!onlyProductionPerHour" ng-class="::{strikethrough: showAsOldResources}">&#x202D;+&#x202D;3958&#x202C;&#x202C;</span><!-- end ngIf: !onlyProductionPerHour -->
						<!-- ngIf: ::numberUnit=='production' -->
						<!-- ngIf: productionPerHour[index] || productionPerHour[index] == 0 -->
					</span><!-- end ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><span ng-repeat="(index, type) in resTypes" class="resource cropValue enough" ng-if="resourceVisibility[index]" ng-class="{notEnough: !enoughStorage(index), enough: enoughStorage(index) && colorPositive}" tooltip="" tooltip-translate="Resource_4">
						<i class="unit_crop_medium_illu resType4"></i>
						<!-- ngIf: !onlyProductionPerHour --><span class="resourceValue" ng-if="!onlyProductionPerHour" ng-class="::{strikethrough: showAsOldResources}">&#x202D;+&#x202D;2971&#x202C;&#x202C;</span><!-- end ngIf: !onlyProductionPerHour -->
						<!-- ngIf: ::numberUnit=='production' -->
						<!-- ngIf: productionPerHour[index] || productionPerHour[index] == 0 -->
					</span><!-- end ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes -->
				</span><!-- end ngIf: checkStorage -->
			
				<!-- ngIf: (consumption || consumption == 0) && consumption != 'false' -->
				<!-- ngIf: population || population == 0 -->
			
				<!-- ngIf: treasures || treasures == 0 -->
			
				<!-- ngIf: stolenGoods || stolenGoods == 0 -->
			
				<!-- ngIf: time || time == 0 -->
			
				<!-- ngIf: enoughResSecs == -1 -->
				<!-- ngIf: enoughResSecs > 0 -->
				<!-- ngIf: capacityHint -->
			
				<div class="iconButton premium npcTrade ng-hide" ng-show="showNpc != undefined"><i class="feature_npcTrader_medium_flat_black"></i></div>
			</div></display-resources>
						</div>
					</div>
				</div>
			
				<div class="upgradeInfo dismantle busy" ng-class="{busy: busy}">
					<!-- ngIf: upgradeButtonClass == 'possible' -->
					<!-- ngIf: upgradeButtonClass == 'notNow' -->
				</div>
			</div>`,
		},
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_20.ogg');
				audio.play();
			}
		},
		onModalClose(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_7.ogg');
				audio.play();
			}
		},
		
		onResize(){
			//let leftpos = (window.innerWidth / 2) - (1920 / 2) - 70;
			let leftpos = (window.innerWidth / 2) - (1920 / 2);
			//console.log(window.innerWidth, leftpos);
			this.villageBackgroundLeft = leftpos+'px';
			
			let maxHeightContent = window.innerHeight - 325;
			maxHeightContent = (maxHeightContent < 550 ? 550 : maxHeightContent);
			this.maxHeightContent = maxHeightContent + 'px';
			this.maxHeightInnerContent = (maxHeightContent - 57 > 0 ? maxHeightContent - 57 : 0) + 'px';
		},
	},
	mounted(){
		this.onModalOpen();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
	},
	unmounted(){
		this.onModalClose();
		
		window.removeEventListener('resize', this.onResize); 
	},
	created(){
		this.gameModel.buildingQueue.show = true;
	},
	components: {
		DisplayResources,
	},
}
</script>